import { useState } from 'react';
import { Icon } from '../../../shared/Icon';
import { speakNorwegian } from '../../../shared/speech';
import type { ExercisePluginProps } from '../types';
import { strings, text } from '../contentFields';

export function VocabularyExposureExercise({ exercise, onComplete, showToast }: ExercisePluginProps) {
  const [saving, setSaving] = useState(false);
  const lemma = text(exercise.content, 'lemma');
  const explanation = text(exercise.content, 'explanation');
  const example = text(exercise.content, 'example');
  const forms = strings(exercise.content, 'forms');
  const partsOfSpeech = strings(exercise.content, 'partsOfSpeech');
  const learnerAdapted = exercise.content.learnerAdapted === true;

  function listen() {
    if (!speakNorwegian(example || lemma)) showToast('Lyd er ikke tilgjengelig i denne nettleseren.');
  }

  async function continueToCheck() {
    setSaving(true);
    await onComplete({
      response: { acknowledged: true },
      result: { exposureCompleted: true },
      evidence: []
    });
  }

  return <>
    <p className="exercise-kicker">MØT ORDET FØR DU TESTER DEG</p>
    <h2 className="exercise-title">{text(exercise.content, 'title', `Møt «${lemma}»`)}</h2>
    <p className="exercise-intro">{learnerAdapted
      ? 'Start med en enkel forklaring og et vanlig eksempel. Deretter møter du betydningen formulert på en ny måte.'
      : 'Les forklaringen og se hvordan ordet brukes. Deretter får du velge betydningen selv.'}</p>
    <article className="vocabulary-exposure-card">
      <div className="vocabulary-exposure-meta"><span>#{String(exercise.content.vocabularyRank ?? '')}</span><span>{partsOfSpeech.join(' · ')}</span></div>
      <strong>{lemma}</strong>
      {learnerAdapted && <span className="learner-explanation-label">ENKEL FORKLARING</span>}
      <p>{explanation}</p>
      {example && <blockquote>«{example}»</blockquote>}
      {forms.length > 1 && <div className="word-chips">{forms.map(form => <i key={form}>{form}</i>)}</div>}
      {learnerAdapted && <small className="dictionary-reference-note">Full ordboktekst er fortsatt tilgjengelig under Ord.</small>}
      <button className="listen-button" onClick={listen}><Icon name="volume" /> {example ? 'Hør eksemplet' : 'Hør ordet'}</button>
    </article>
    <div className="speak-actions"><button className="exercise-next" disabled={saving} onClick={() => void continueToCheck()}>Prøv betydningen <Icon name="arrow" /></button></div>
  </>;
}
